// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e4567b04","480":"656b1fa3","972":"e2fffe54"}[chunkId] + ".chunk.js";
};